import React from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

export default function Footer() {
  return <footer className="text-center bg-light pd-5 m-0">
    <p className="text-muted"><a href="http://kingstonjugglers.club/">Queen’s and Kingston Juggler’s Clubs</a>. All rights reserved.</p> 
        </footer>
}


